// extracted by mini-css-extract-plugin
export default {"wrapper":"Register_wrapper__gqciQ","back":"Register_back__5sk5e","icon":"Register_icon__CAQsJ"};